/** Drag-and-drop shell for TodayView — overlay tracking + body drag class. */
import {
  useSensors,
  useSensor,
  PointerSensor,
  TouchSensor,
} from '@dnd-kit/core';
import { useTaskDragAndDrop } from '@/features/tasks/hooks/list/use-list-dnd.js';

export const useTodayViewDnd = (allTasks) => {
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
    useSensor(TouchSensor, {
      activationConstraint: { delay: 200, tolerance: 5 },
    }),
  );

  const { activeItem, handleDragStart, handleDragCancel } =
    useTaskDragAndDrop(allTasks);

  const onDragStart = (event) => {
    document.body.classList.add('dnd-is-dragging');
    handleDragStart(event);
  };

  const onDragCancel = () => {
    document.body.classList.remove('dnd-is-dragging');
    handleDragCancel();
  };

  const onDragEnd = () => {
    document.body.classList.remove('dnd-is-dragging');
    handleDragCancel();
  };

  return { sensors, activeItem, onDragStart, onDragEnd, onDragCancel };
};
